import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import { useInboundDeliveryStore } from '../stores/inboundDeliveryStore';
import type { InboundDeliveryResponse } from './common/inboundDeliveryResponse';
import type { DeliveryStatus } from 'shared/deliveries/domain/deliveryStatus';

export interface UpdateInboundDelivery {
  id: string;
  name: string;
  note: string | null;
  status: DeliveryStatus;
  customer: string | null;
  customerReference: string | null;
  plannedStartUtc: string | null;
  plannedFinishUtc: string | null;
  rows: UpdateInboundDeliveryRow[];
}

export interface UpdateInboundDeliveryRow {
  id?: string;
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  note: string | null;
}

export interface UpdateInboundDeliveryResponse {
  ok: true;
  delivery: InboundDeliveryResponse;
}

export function useUpdateInboundDeliveryApi() {
  const store = useInboundDeliveryStore();

  return useUpdateEntityApi<UpdateInboundDelivery, UpdateInboundDeliveryResponse>({
    url: 'delivery/inbound',
    translate: (t) => t.inboundDelivery.actions.update,
    async processOk(response) {
      const json = (await response.json()) as InboundDeliveryResponse;
      store.add(json);
      return {
        ok: true,
        delivery: json,
      };
    },
  });
}
